import React, { useEffect } from 'react';
import { cn } from '@/lib/utils';

interface ConfettiProps {
  show: boolean;
  onComplete?: () => void;
  duration?: number;
}

export const Confetti: React.FC<ConfettiProps> = ({ 
  show, 
  onComplete, 
  duration = 3000 
}) => {
  useEffect(() => {
    if (show && onComplete) {
      const timer = setTimeout(onComplete, duration);
      return () => clearTimeout(timer);
    }
  }, [show, onComplete, duration]);

  useEffect(() => {
    if (show) {
      // Add keyframes animation to the document
      const style = document.createElement('style');
      style.textContent = `
        @keyframes confetti-fall {
          0% {
            transform: translateY(-100vh) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(720deg);
            opacity: 0;
          }
        }
        
        .animate-confetti-fall {
          animation: confetti-fall 3s linear forwards;
        }
      `;
      document.head.appendChild(style);

      return () => {
        document.head.removeChild(style);
      };
    }
  }, [show]);

  if (!show) return null;

  // Generate random confetti pieces
  const confettiPieces = Array.from({ length: 50 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    animationDelay: Math.random() * 3,
    color: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3'][Math.floor(Math.random() * 6)]
  }));

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {confettiPieces.map((piece) => (
        <div
          key={piece.id}
          className={cn(
            "absolute w-2 h-2 opacity-80 animate-confetti-fall",
            "rounded-sm"
          )}
          style={{
            left: `${piece.left}%`,
            backgroundColor: piece.color,
            animationDelay: `${piece.animationDelay}s`,
            animationDuration: '3s'
          }}
        />
      ))}
    </div>
  );
}; 